	import React, {Fragment, memo} from 'react';
import {useIntl} from 'react-intl';

import {styleMods} from '../../utils';
import Block from '../block';
import IntlString, {intlString} from '../intl-string';
import Link from '../link';

import style from './link-list.module.scss';

export default memo(
	/**
	 * @param {{
	 *   style: import('../../../tmp/graphql-types').PageElementFrag_PageElementLinkList_Fragment["linkListStyle"],
	 *   title: import('../../../tmp/graphql-types').PageElementFrag_PageElementLinkList_Fragment["linkListTitle"],
	 *   entries: import('../../../tmp/graphql-types').PageElementFrag_PageElementLinkList_Fragment["linkListEntries"],
	 * }} props
	 * @returns {React.ReactElement} ...
	 */
	function LinkList({style: listStyle, title, entries}) {
		const intl = useIntl();

		return (
			<Block>
				<div className={styleMods(style, 'base', listStyle || 'light')}>
					{title && (
						<h1 className={style.title}>
							<IntlString {...title} />
						</h1>
					)}

					<ul className={style.list}>
						{entries.map(({title: title2, text, url}, i) => {
							const content = (
								<Fragment>
									{title2 && (
										<h2 className={style.entryTitle}>
											<IntlString {...title2} />
										</h2>
									)}

									{text && (
										<div className={style.entryText}>
											<IntlString {...text} />
										</div>
									)}
								</Fragment>
							);

							const content2 = (() => {
								if (url) {
									return (
										<Link
											className={style.entryLink}
											href={intlString(intl, url)}
										>
											{content}
										</Link>
									);
								} else {
									return content;
								}
							})();

							return (
								<li
									key={i}
									className={styleMods(style, 'entry', {hasUrl: !!url})}
								>
									{content2}
								</li>
							);
						})}
					</ul>
				</div>
			</Block>
		);
	}
);
